import * as React from 'react'
import { convertSeconds } from '../../../../_utils/time'
import { RelativeDateDisplayMetric } from '@pushly/aqe/lib/enums'
import { CatalogItemType, JourneyActionType, TriggerType } from '@pushly/models/lib/enums'
import { JourneyStep } from '../../types/journey-nodes'
import { Journey } from '../../types/journey-api-response'
import { RecommendationSource } from '@pushly/models/lib/enums/recommendations/recommendation-source'
import { BLUECONIC_DISPLAY_VALUE } from '../../editors/send-recommended-notification-editor/blueconic/constants'
import { JourneyType, StepType } from '@pushly/models/lib/enums/journeys'
import { safeEnumFromValue } from '@pushly/models'
import { NotificationPayload } from '../../types/notification-payload'

// region Node Content

export const getSubtitle = (node: JourneyStep, journey?: Journey) => {
    if (!journey) {
        return null
    }

    let subtitle: React.ReactNode
    const stepType = safeEnumFromValue(StepType, node.type)

    switch (stepType) {
        case StepType.TRIGGER:
            const journeyType = safeEnumFromValue(JourneyType, journey.campaign_type ?? journey.type)
            if (journeyType === JourneyType.TRIGGER) {
                const configType = safeEnumFromValue(TriggerType, node.configuration.type)
                switch (configType) {
                    case TriggerType.ABANDONED_CART:
                        subtitle = 'E-Commerce: Abandoned Cart'
                        break

                    case TriggerType.ADD_TO_CART:
                        subtitle = 'E-Commerce: Add To Cart'
                        break

                    case TriggerType.ABANDONED_VIEW:
                        subtitle = 'E-Commerce: Abandoned Browse'
                        break

                    case TriggerType.NOTIFICATION_CLICK:
                        subtitle = 'User clicks a notification'
                        break

                    case TriggerType.SUBSCRIBED:
                        subtitle = 'User Subscribes and matches criteria'
                        break

                    default:
                        subtitle = null
                        break
                }
            } else {
                subtitle = 'Recurring'
            }
            break
        case StepType.DELAY:
            const displayDelay = convertSeconds(
                node.configuration.params.delay_seconds,
                RelativeDateDisplayMetric[node.configuration.params.qualifier.toUpperCase()],
            )

            subtitle = `${displayDelay} ${node.configuration.params.qualifier}`
            break

        case StepType.ACTION:
            if (node.configuration.type === JourneyActionType.SEND_RECOMMENDED_NOTIFICATION) {
                subtitle = `Source: ${
                    node.configuration.params.recommendation_source === RecommendationSource.BLUECONIC
                        ? BLUECONIC_DISPLAY_VALUE
                        : node.configuration.params.recommendation_source ?? 'Unspecified'
                }`
            } else {
                const notification: NotificationPayload = node.configuration.params.notification
                subtitle = notification?.template?.channels?.default?.title ?? ''
            }
            break

        default:
            subtitle = null
            break
    }

    return subtitle
}

export const getJourneyTriggerItemType = (journey: Journey): CatalogItemType | undefined => {
    if (!journey?.steps) {
        console.warn('Journey steps are undefined, cannot determine item type.')
        return undefined
    }

    const triggerStep = journey.steps.find((step) => step.type === StepType.TRIGGER)

    const itemType = triggerStep?.configuration?.params?.item_type

    // Ensure we return a valid CatalogItemType or null
    if (itemType && Object.values(CatalogItemType).includes(itemType as CatalogItemType)) {
        return itemType as CatalogItemType
    }

    return undefined
}

// endregion
